export { type LatestEndpointDefinition as EndpointDefinition } from "../orpc-client/api/contract-latest.js";
